import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout/index'
import fullscreen from '@/layout/fullscreen'
import store from '@/store'
Vue.use(Router)

let router =  new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/index/home')
    }, {
      path: '/login',
      name: 'login',
      component: () => import('@/views/user/login')
    }, {
      path: '/register',
      name: 'register',
      component: () => import('@/views/user/register')
    },
    {
      path: '/team',
      name: 'team',
      redirect: { name: "teamCreate" },
      component: layout,
      meta:{name:'球队'},
      children: [
        {
          path: 'select',
          name: "choice",
          component: () => import('@/views/team/select'),
          meta: { name: '选择球队', requireLogin: true,},
        },
        {
          path: 'create',
          name: "teamCreate",
          component: () => import('@/views/team/create'),
          meta: { name: '创建球队', team: false, requireLogin: true,},
        }, {
          path: 'team',
          name: "teamManagement",
          component: () => import('@/views/team/team'),
          meta: { requireLogin: true, leader:true ,name: '球队管理'}
        }, {
          path: 'submit',
          name: "submitResult",
          component: () => import('@/views/team/submitTeam'),
          meta: { requireLogin: true, leader: true , name: '提交审核'}
        }, {
          path: 'result',
          name: "teamResult",
          component: () => import('@/views/team/result'),
          meta: { requireLogin: true, leader: true, name: '审核结果' }
        }]
    },
    {
      path: '/member',
      name: 'member',
      redirect: { name: "memberPage" },
      meta: { name: '用户' },
      component: layout,
      children: [
        {
          path: 'memberpage',
          name: "memberPage",
          component: () => import('@/views/member/member'),
          meta: { requireLogin: true, name: '邀请列表',login:true}
        }, {
          path: 'invitedpage',
          name: "invitedPage",
          component: () => import('@/views/member/invited'),
          meta: { requireLogin: true, team: false,name: '接受邀请'}
        }, {
          path: 'profile',
          name: "profile",
          component: () => import('@/views/member/profile'),
          meta: { requireLogin: true, team: true,name: '完善信息'}
        }, {
          path: 'final',
          name: "final",
          component: () => import('@/views/member/final'),
          meta: { requireLogin: true, team: true, name: '完成填写' }
        }]
    }
  ]
})

let whiteList = ['/login','/','/doc']

router.beforeEach(async (to, from, next) => {
    if (whiteList.indexOf(to.path) >-1){
      console.log("to:", to.path, " code:", whiteList.indexOf(to.path))
      next()
    }

  if (to.matched.some(record => record.meta.requireLogin)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // 确保一定要调用 next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js